export default __webpack_public_path__ + "static/media/27.7a9dacf3.jpg";